import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    changeAccountStatus: {
        id: 'changeAccountStatus',
        defaultMessage: 'Change Account Status',
    },
    viewLimits: {
        id: 'viewLimits',
        defaultMessage: 'View Limits',
    },
});

export default enumMessages;
